import React, { useState, useEffect } from "react";
import {
  Grid,
  Button,
  Typography,
  Box,
  Select,
  MenuItem,
  Chip,
  IconButton,
  Snackbar
} from "@material-ui/core";
import Close from "@material-ui/icons/Close"
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import { DropzoneDialogBase } from "material-ui-dropzone";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import { useSelector } from "react-redux";
import ExpandMoreSharpIcon from "@material-ui/icons/ExpandMoreSharp";

const STYLED_SELECT = withStyles((theme) => ({
  root: {
    fontSize: "0.8rem",
    border: "1px solid " + theme.palette.eBackground.base + " !important",
    borderRadius: "4px",
    padding: "7px 10px",
    color: theme.palette.eMedium.base,
  },
  input: {},
  select: {
    "&:focus": {
      borderRadius: "4px",
    },
    whiteSpace: "nowrap",
  },
  icon: {
    color: theme.palette.eMedium.base,
  },
}))(Select);

export const STYLED_MENU_ITEM = withStyles((theme) => ({
  root: {
    justifyContent: "flex-start !important",
    color: theme.palette.eRich.base + " !important",
    fontSize: "0.8rem",
  },
}))(MenuItem);

const useStyles = makeStyles((theme) => ({
  textFieldsContainer: {
    minHeight: "57vh",
    padding: "2%",
  },
  containers: {
    padding: "0 2%",
  },
  buttonGrid: {
    textAlign: "right",
    margin: "0.4rem 0",
  },
  dividerStyle: {
    width: "100%",
    margin: "1.5rem 0",
    textAlign: "center",
    backgroundColor: theme.palette.eLight.base,
  },
  nextButton: {
    padding: "3% 30%",
    marginLeft: "1rem",
    marginRight: "3rem",
    color: theme.palette.eWhite.base,
    backgroundColor: theme.palette.ePrimary.base,
    borderRadius: "2rem",
    "&:hover": {
      backgroundColor: theme.palette.ePrimary.hover,
    },
  },
  blueColor: {
    color: theme.palette.ePrimary.base,
  },
  dialogProps: {
    padding: "0 !important",
    "& .MuiDialogTitle-root": {
      padding: "0 !important"
    }
  },
  contentColor: {
    background: theme.palette.ePrimary.base,
    color: theme.palette.eWhite.base,
    paddingLeft: "3%",
  },
  attachButton: {
    color: theme.palette.eWhite.base,
    backgroundColor: theme.palette.ePrimary.base,
    "&:hover": {
      backgroundColor: theme.palette.ePrimary.hover,
    },
    whiteSpace: "nowrap"
  },
  dropzonAreaMargin: {
    marginTop: "3rem"
  },
  selectWidth: {
    width: "90%",
  },
  chipStyle: {
    maxWidth: "-webkit-fill-available",
    marginTop: "0.438rem",
  },
  previewChip: {
    paddingTop: "2% !important",
    paddingBottom: "1% !important",
    wordWrap: "break-word !important",
    whiteSpace: "normal !important"
  },
  closeIcon: {
    color: theme.palette.eWhite.base,
  },
  rightIcon: {
    textAlign: "-webkit-right",
  },
  error: {
    color: theme?.palette?.eDanger?.dark
  }
}));

export default function DocumentSelect(props) {
  const { label,
    index,
    fileArray,
    setFileArray,
    fileTypes,
    documentRequireError,
    content,
    fileNumber,
    docKey,
    docValue,
  } = props;
  const classes = useStyles();

  const labels = useSelector((store) => store?.labels?.data?.getLabels?.E_DOCUMENT_UPLOAD);
  const maxFileSize = useSelector((store) => store?.parametersWidgets?.ParameterLookup?.E_NCR_MAX_FILE_SIZE);
  const alertTimeout = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_USAGE_MAIL_ALERT_TIMEOUT);
  const maxFiles = useSelector((store) => store?.parametersWidgets?.ParameterLookup?.E_UPLOAD_MAX_FILE);
  
  const [open, setOpen] = useState(false);
  const [uploadDropBocContent, setuploadDropBocContent] = useState("")
  const [localFiles, setLocalFiles] = useState([]);
  const [snackBar, setSnackBar] = useState(false);
  const [snackBarMsg, setSnackBarMsg] = useState("");
  const [snackBarSeverity, setSnackBarSeverity] = useState("success");

  const closeSnackBar = () => {
    setSnackBar(false);
  }
  useEffect(() => {
    setuploadDropBocContent(content?.answer);
  }, [content])

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setLocalFiles([]);
  };
  const handleSave = () => {
    if(localFiles?.length !== 0) {
      let newFileArray = [];
      localFiles.forEach(item => {
        let fileObj = {};
        fileObj["fileType"] = item?.file?.name.substring(item?.file?.name.lastIndexOf(".")+1).toLowerCase();
        fileObj["fileName"] = item?.file?.name.replace(/\.([0-9a-z]+)(?=[?#])|(\.)(?:[\w]+)$/, "");
        fileObj["fileContent"] = item?.data?.split(';base64,')[1];
        newFileArray.push(fileObj);
      })
      let documentObj = {
        dropDownCode: docKey,
        dropDownValue: docValue,
        index: index,
        files: fileArray[index]?.files ? [...fileArray[index].files, ...newFileArray] : [...newFileArray],
      };
      let additionalFilesArray = fileArray;
      additionalFilesArray[index] = documentObj;
      newFileArray = additionalFilesArray;
      setFileArray([...newFileArray]);
    }
    setLocalFiles([]);
    setOpen(false);
  };
  const handleDelete = (file) => {
    let newFiles = [];
    let localFilesArray = fileArray[index]?.files;
    localFilesArray.forEach((item) => {
      if (item !== file) {
        newFiles.push(item);
      }
    });
    let additionalFilesArray = fileArray;
    additionalFilesArray[index].files = newFiles;
    newFiles = additionalFilesArray;
    setFileArray([...newFiles]);
  };
  const onAdd = (files) => {
    let data=  fileArray?.map((item)=> item?.files);
    let filenamesss=data && data?.map((item)=> item[0]?.fileName);
    if(files?.length !== 0) {
      let newFiles = [];
      let duplicateFiles = [];
      let alreadyAdded = fileArray[index]?.files;
      if (maxFiles == 1) {
        if(localFiles.length > 0) {
          setSnackBarSeverity("error");
          let snackMsg = labels?.E_DOCUMENT_UPLOAD_FILE_MAX_FILE_ERROR_MSG;
          setSnackBarMsg(snackMsg);
          setSnackBar(true);
        } else {
          let filenema=files[0]?.file?.name.replace(/\.([0-9a-z]+)(?=[?#])|(\.)(?:[\w]+)$/, "")
         let duplicate=false
         filenamesss.filter((each)=>{
         if(each===filenema){
          duplicate=true}}
        )
          if( duplicate ) {
            setSnackBarSeverity("error");
            let snackMsg = "";
              snackMsg = snackMsg + labels?.E_DOCUMENT_UPLOAD_FILE_ALREADY_ADDED_MSG?.replace("*filename*",filenema);
            setSnackBarMsg(snackMsg);
            setSnackBar(true);
          }else{
          setLocalFiles(files);
          setSnackBarSeverity("success");
          let snackMsg = labels?.E_DOCUMENT_UPLOAD_FILE_ADDED_MSG?.replace("*filename*",files[0].file?.name);
          setSnackBarMsg(snackMsg);
          setSnackBar(true);}
        }
      } else {
        files.forEach(file => {
          let isExist = false;
          localFiles.forEach((localFile) => {
            if(localFile?.file?.name === file?.file?.name) isExist = true;
          })
          alreadyAdded && alreadyAdded.forEach((addedFile) => {
            if(addedFile?.fileName === file?.file?.name) isExist = true;
          })
          if(!isExist) newFiles.push(file);
          else duplicateFiles.push(file);
        })
        if(duplicateFiles?.length) {
          setSnackBarSeverity("error");
          let snackMsg = "";
          duplicateFiles.forEach(file => {
            snackMsg = snackMsg + labels?.E_DOCUMENT_UPLOAD_FILE_ALREADY_ADDED_MSG?.replace("*filename*",file?.file?.name);
          })
          setSnackBarMsg(snackMsg);
          setSnackBar(true);
        } else if(newFiles?.length) {
          setSnackBarSeverity("success");
          let snackMsg = "";
          newFiles.forEach(file => {
            snackMsg = snackMsg + labels?.E_DOCUMENT_UPLOAD_FILE_ADDED_MSG?.replace("*filename*",file?.file?.name);
          })
          setLocalFiles([].concat(localFiles, newFiles));
          setSnackBarMsg(snackMsg);
          setSnackBar(true);
        }
      }
    }
  }
  const onDelete = (file) => {
    let updatedFiles = localFiles.filter(localFile => localFile?.file?.name !== file?.file?.name);
    setLocalFiles(updatedFiles);
  }
  const dialogTitle = () => (
    <Grid
      container
      alignItems="center"
      className={classes.contentColor}
      justify="space-between"
    >
      <Grid item xs={10}>
        <Typography variant="subtitle2">{labels?.E_UPLOAD_FILES}</Typography>
      </Grid>
      <Grid item xs={2} className={classes.rightIcon}>
        <IconButton aria-label="close" onClick={handleClose}>
          <Close className={classes.closeIcon} />
        </IconButton>
      </Grid>
    </Grid>
  )
  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant="body2">
          <Box>{label}</Box>
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Button
          type="file"
          variant="contained"
          onClick={handleOpen}
          className={classes.attachButton}
          startIcon={<AttachFileIcon></AttachFileIcon>}
          disabled={fileNumber == 0 ? true : false}
        >
          {labels?.E_ATTACH_FILE}
        </Button>
        {(documentRequireError && fileArray[index]?.files?.length == 0) && <Typography variant="body2" className={classes.error}>
          {labels?.E_UPLOAD_DOCUMENT_REQUIRED}
        </Typography>}
      </Grid>
      {
        fileArray[index]?.files?.length !== 0 &&
          fileArray[index]?.files?.map((item) => (
            <Grid item xs={12}>
              <Chip
                label={item.fileName}
                onDelete={(e) => handleDelete(item)}
                className={classes.chipStyle}
              />
            </Grid>
          ))
      }
      <DropzoneDialogBase
        dialogTitle={dialogTitle()}
        fileObjects={localFiles}
        open={open}
        onAdd={onAdd}
        onDelete={onDelete}
        onClose={handleClose}
        onSave={handleSave}
        acceptedFiles={fileTypes?.split(",")}
        maxFileSize={Number(maxFileSize) * 1024 * 1024}
        filesLimit={fileNumber ? fileNumber : 1}
        showPreviews={true}
        showFileNamesInPreview={true}
        dialogProps={{ classes: { root: classes.dialogProps }}}
        useChipsForPreview
        showAlerts={['error', 'info']}
        previewChipProps={{ classes: { label: classes.previewChip } }}
        dropzoneText={
          <Typography variant="body2" className={classes.dropzonAreaMargin}
          dangerouslySetInnerHTML={{
            __html: uploadDropBocContent,
          }}/>
        }
      />
      <Snackbar open={snackBar} autoHideDuration={alertTimeout} 
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        onClose={closeSnackBar}
        >
          <MuiAlert onClose={closeSnackBar} variant="filled"
            severity={snackBarSeverity} 
            icon={
              snackBarSeverity === "error" ? 
                <ErrorIcon />
              : <CheckCircleIcon />
            }
          >
            {snackBarMsg} 
          </MuiAlert>
      </Snackbar>
    </Grid>
  );
}